import * as actionTypes from "./TimeSheetType";

const INITIAL_STATE = {
    prjList: [],
    actList:[],
	timeSheetList:[],
	timesheetMonth:[],
	exportTimeSheet:[],
};

const TimeSheetReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case actionTypes.SETPRJLIST:
			return {
				...state,
				prjList: action.payload.list,
			};
            case actionTypes.SETACTIVITYLIST:
			return {
				...state,
				actList: action.payload.list,
			};
			case actionTypes.SETTIMESHEETLIST:
			return {
				...state,
				timeSheetList: action.payload.list,
			};
			case actionTypes.SETMONTHLIST:
			return {
				...state,
				timesheetMonth: action.payload.list,
			};
			case actionTypes.SETEXPORTLIST:
			return {
				...state,
				exportTimeSheet: action.payload.list,
			};
    default:
			return state;
    }
}

export default TimeSheetReducer;